module.exports = __webpack_public_path__ + "static/media/unfiltered.fb68c3fc.svg";